import base from "../baseurl";
import token from "../getTk";

const showAll = async (companyReportId, depositedAmount) => {
  console.log(companyReportId, depositedAmount);
  const tokenA = token.get();
  const api = base.extend({
    hooks: {
      beforeRequest: [
        (request) => {
          request.headers.set("jwt", `${tokenA}`);
        },
      ],
    },
  });

  const show = await api
    .post("weekly-fees/update", {
      json: {
        companyReportId,
        depositedAmount,
      },
    })
    .json();
  return show;
};

export default showAll;
